export function useSignedData() {
  return window.signed;
}
